import { styles } from "dom7";
import { useEffect, useState, useRef } from "react";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import Srcset from "./Srcset";
import style from "../common/common.module.scss";
import MobileSizeComp from "./MobileSizeComp";

import useOutsideClick from "@/hooks/useOutsideClick";
import { viewOOSRecommodation } from "./Nosto";
import TickMarkComponent from "../Logos/TickMark";
import { useDispatch, useSelector } from "react-redux";
import { showCharityActiveMessage } from "@/redux/actions/generalAction";
import { reportError } from "@/helpers/errorHelper";

const Dropdown = ({
  ArrowDown,
  data,
  dropdownTitle,
  showStickyDropdown,
  disabled,
  selected,
  setSelected,
  isDropdownOpen,
  parentHandleToggle,
  isDropup,
  AddToBag,
  handleOutsideClick = null,
  sizeGuideType,
  loading = false,
  mobileSizeComp,
  innerDropUpTitle,
  sizeVariants,
  productId,
  singleQuantity,
  charityClassName,
  dropdownType,
  fastShippingVariants,
  isGiftDropup
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState(false);
  const isMobile = useMediaQuery("(max-width: 767px)");
  const dispatch= useDispatch();
  var scrollPosition = 0;
  const handleActive = (e, ele) => {
    if (setSelected) {
      setSelected(ele);
      disabled?.includes(ele) && viewOOSRecommodation(productId, sizeVariants[ele].id);
      dispatch(showCharityActiveMessage(true))
    }
    setActive(ele);
  };

  const isPWA = useSelector((state) => state.pwa.is_PWA);

  const handleToggle = () => {
    // If toggle handler function is passed as props
    if (parentHandleToggle) parentHandleToggle(!isOpen);

    setIsOpen(!isOpen); 
  };

  useEffect(() => {
    // If selected swatch is set from parent component
    if (typeof selected != "undefined") {
      setActive(selected);
    }
  }, [selected]);

  useEffect(() => {
    // If dropdown needs to be opened from parent component
    if (typeof isDropdownOpen != "undefined") {
      setIsOpen(isDropdownOpen);
    }
  }, [isDropdownOpen]);

  useEffect(() => {
    const $body = document.querySelector('body');
    // Note: for PDPs except giftcard, .custom-dropdown has two instances ie for charity and size. For below condition, it selectes the charity dropdown. 
    // If charity dropdown is removed then size dropdown wont scroll into view
    // For giftcard PDP, .custom-dropdown has only one instance.
    const dropdownPosition = document.querySelector('.custom-dropdown');
    if (typeof document !== "undefined") {
      if (isDropup) {
        document.body.classList.add("dropup");
      }
      if(dropdownPosition) {
        scrollPosition = dropdownPosition.getBoundingClientRect().top;
      }

      if(isMobile) {
        if (isDropup && isDropdownOpen) {          
            document.querySelector("html").classList.add('no_scroll', 'fixed'); 
            $body.classList.add('no_scroll', 'fixed'); 
            $body.style.top = `-${scrollPosition}px`;
            $body.style.width = '100%';
        }
        else {        
          document.querySelector("html").classList.remove('no_scroll', 'fixed');
          $body.classList.remove('no_scroll', 'fixed'); 
          $body.style.removeProperty('top');
          $body.style.removeProperty('width');
          // Scroll dropdown into view. Fix is added only for griftcard PDP 
          if(isGiftDropup && dropdownRef.current) {
            dropdownRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
          } else {
            window.scrollTo(0, scrollPosition);
          }
        }
      }
    }
  }, [isDropup, isDropdownOpen]);

  const dropdownRef = useRef(null);
  const dropupRef = useRef(null);
  const dropdownLabelRef = useRef(null);

  useOutsideClick(dropdownRef, handleOutsideClick);
  useOutsideClick(dropupRef, handleOutsideClick);

  // New useEffect to handle Escape key press
  useEffect(() => {
    const handleKeyDown = (event) => {
      try {
        if (event?.key === 'Escape' && isOpen) {
          setIsOpen(false);
          if (parentHandleToggle) parentHandleToggle(false);
          // Add the 'focusElement' class to the dropdownLabelRef element
          if (dropdownLabelRef.current) {
            dropdownLabelRef.current.classList.add('focusElement');
          }
          dropdownLabelRef.current.focus(); // Focus on the dropdown label
        }
          // Check for Tab key press
        else if(event?.key === 'Tab' && !isOpen) {
          if (dropdownLabelRef.current) {
            dropdownLabelRef.current.classList.remove('focusElement');
          }
          // Check if the dropdownLabelRef is not focused
        }
      } catch (error) {
        reportError(error); // Log error using reportError function
        reportError("dropdown js key error");
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, parentHandleToggle]);

  //ada - retain focus after dropdown select
  const handleKeyDownSelect = (e) =>{
    const activeElement = document.activeElement;
    if(e?.key=='Enter'){
      if(activeElement){
        activeElement?.closest(".dropdown-list")?.previousElementSibling?.focus()
      }
    }
  }

  return (
    <div
      className={`typography-wrap ${
        typeof showStickyDropdown != "undefined" && !showStickyDropdown
          ? "d-none"
          : ""
      }`}
      ref={dropdownRef}
    >
      <div
        className={`custom-dropdown ${isDropup ? "dropup" : ""} ${
          isOpen ? "open" : ""
        }`}
      >
        <div
          ref={dropdownLabelRef}
          tabIndex={0}
          onClick={() => {
            if(!loading) {
              handleToggle();
            }
          }}
          className={`dropdown-lable small ${active ? `normal-md` : ""} ${loading ? "loading" : ""}`}
        >
          <span className="text">
            {active ? `${dropdownTitle} ${active}` : `${dropdownTitle}` }
          </span>
          <Srcset
            height={15}
            width={15}
            className="right"
            requirePath={true}
            svgFile={true}
            src={ArrowDown}
            alt="Right arrow"
          />
        </div>
        {!loading && <div className={`${isPWA && isDropup ? "addBottomMargin_APPNav ": ""} dropdown-list`}>
          {isDropup && (
            <div className="dropup-overlay" onClick={handleToggle}></div>
          )}
          <ul onClick={handleToggle} className={`dropdown-ul ${isDropup && !sizeGuideType ? "bottom_49" : null}`}>
            {isDropup && (
              <li className="dropup-label">
                <span className="text small-xs mobile-pdp-title">{innerDropUpTitle}</span>
                <Srcset
                  className={` right ${style.dropup_logo}`}
                  height={15}
                  width={15}
                  requirePath={true}
                  svgFile={true}
                  src={ArrowDown}
                />
              </li>
            )}
            {data.map((ele, i) => (
              <li
                tabIndex={0}
                key={i}
                className={`${style.dropdown_item}
                  ${charityClassName && active === ele ? "" :
                    (disabled?.includes(ele) ? "disable" :
                      (active === ele ? "active" : "")
                    )}`
                 }
                onClick={(e) => {
                  handleActive(e, ele);
                }}
                onKeyDown={(e)=>{
                  handleKeyDownSelect(e);
                }}
              >
                {fastShippingVariants?.includes(ele) && <span className={`fast_shipping_dot ${style.fast_shipping_badge} ${style.dropdown_badge}`}></span>}
                <span className={`${dropdownType === "Charity"?"charity_main_div":""}`}>
                {/* OS-1495 : To show tickmark in charity dropdown */}
                {
                  dropdownType === "Charity" &&
                  <div className="charity_icon_div">
                    {active === ele && charityClassName &&
                      <div >
                        <TickMarkComponent />
                      </div>
                    }
                  </div>
                }
                {ele} {/* shows option in dropdown */}
                </span>
                {isMobile && (singleQuantity?.includes(ele) || disabled?.includes(ele)) && <>&nbsp;-&nbsp;</>} {/* shows "-" only for mobile */}
                <span className={`optional-text 
                ${singleQuantity?.includes(ele) ? "last-one" : ""} 
                ${disabled?.includes(ele) ? "hover" : ""}`}>
                  {/* optional text for dropdown values */}
                  {disabled?.includes(ele) ? "check for alternatives" : 
                    singleQuantity?.includes(ele) ? "last one available" : ""}
                </span>
              </li>
            ))}
          </ul>
          {isDropup && mobileSizeComp}
        </div>}
      </div>
    </div>
  );
};

export default Dropdown;
